/*
 * @Author: cmchiu
 * @Date: 2022-03-31 17:05:41
 * @LastEditTime: 2022-07-29 11:18:13
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\router\routes.js
 *
 */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        name: '_home',
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'Home',
                component: () => import('@/views/Home'),
                meta: { title: '首頁', icon: 'el-icon-s-home' },
            },
        ],
    },
    {
        path: '/',
        component: Layout,
        meta: { title: '公佈欄' },
        redirect: '/board',
        children: [
            {
                path: 'board',
                name: 'Board',
                component: () => import('@/views/Board'),
            },
            {
                path: 'board/postnews',
                name: 'PostNews',
                component: () => import('@/views/PostNews'),
                meta: { title: '公告訊息' },
            },
        ],
    },
    {
        path: '/',
        component: Layout,
        meta: { title: '活動快訊' },
        redirect: '/activities',
        children: [
            {
                path: 'activities',
                name: 'Activities',
                component: () => import('@/views/Activities'),
            },
            {
                path: 'activities/postnews',
                name: 'PostNews',
                component: () => import('@/views/PostNews'),
                meta: { title: '活動訊息' },
            },
        ],
    },
    {
        path: '/academic',
        component: Layout,
        meta: { title: '進修學制' },
        redirect: '/academic/cbnpbn',
        children: [
            {
                path: 'college',
                name: 'college',
                component: () => import('@/views/academic/college'),
                meta: { title: '總覽' },
            },
            {
                path: 'cbnpbn',
                name: 'cbnpbn',
                component: () => import('@/views/academic/cbnpbn'),
            },
        ],
    },
    {
        path: '/manage',
        component: Layout,
        meta: { title: '行政單位' },
        redirect: '/manage/manage',
        children: [
            {
                path: 'manage',
                name: 'manage',
                component: () => import('@/views/manage/manage'),
                meta: { title: '總覽' },
            },
            {
                path: 'postdept/:blockID',
                name: 'PostDept',
                component: () => import('@/views/manage/PostDept'),
                meta: { title: '系所發展部' },
            },
        ],
    },
    {
        path: '/information',
        component: Layout,
        meta: { title: '教務學務' },
        redirect: '/information/information',
        children: [
            {
                path: 'information',
                name: 'information',
                component: () => import('@/views/information/information'),
            },
            {
                path: 'studyrule',
                name: 'studyrule',
                component: () => import('@/views/information/studyrule'),
            },
        ],
    },
    {
        path: '/source',
        component: Layout,
        meta: { title: '學習資源' },
        redirect: '/source/source',
        children: [
            {
                path: 'source',
                name: 'source',
                component: () => import('@/views/source/source'),
                meta: { title: '總覽' },
            },
        ],
    },
    {
        path: '/award',
        component: Layout,
        meta: { title: '獎助學金' },
        redirect: '/award/award',
        children: [
            {
                path: 'award',
                name: 'award',
                component: () => import('@/views/award/award'),
                meta: { title: '總覽' },
            },
            {
                path: 'postlist/:blockID/:stID/:stName',
                name: 'PostList',
                component: () => import('@/views/award/PostList'),
                meta: { title: 'XXXX風雲榜' },
                children: [
                    {
                        path: 'postnews',
                        name: 'PostNews',
                        component: () => import('@/views/PostNews'),
                        meta: { title: '風雲榜內容' },
                    },
                ],
            },
            {
                path: 'postnews',
                name: 'PostNews',
                component: () => import('@/views/PostNews'),
                meta: { title: '風雲榜內容' },
            },
        ],
    },
    {
        path: '/service',
        component: Layout,
        meta: { title: '資訊服務' },
        redirect: '/service/service',
        children: [
            {
                path: 'service',
                name: 'service',
                component: () => import('@/views/service/service'),
            },
        ],
    },
    {
        path: '/calendar',
        component: Layout,
        meta: { title: '行事曆' },
        redirect: '/calendar/schedule',
        children: [
            {
                path: 'schedule',
                name: 'schedule',
                component: () => import('@/views/calendar/schedule'),
            },
            {
                path: 'postnews',
                name: 'PostNews',
                component: () => import('@/views/PostNews'),
                meta: { title: '下載學年期行事曆' },
            },
        ],
    },
    /* {
        path: '/404',
        name: 'error_404',
        meta: {
            hideInMenu: true,
            keepAlive: true,
        },
        component: () => import('@/views/error-page/404.vue'),
    }, */
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
    /* {
        path: '/alumni',
        // component: Layout,
        name: 'alumni',
        beforeEnter: () => {
            window.location.href = '//campus2.sce.pccu.edu.tw/alumni/'
        },
    }, */
]

export default [...constantRoutes, ...asyncRoutes]
